import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BlogCard from "./widgets/BlogCard";

const ListSection = (props) => {
  const { t } = useTranslation();
  const blogs = useSelector((state) => state.main.blogs);

  return (
    <Fragment>
      {blogs.length > 0 ? (<section ref={props.sectionRef} className="page-section card-saa">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="mt-0">{t('LANDING_PAGE_BLOG_HEADER_LABEL')}</h2>
              <hr className="divider my-4" />
              <p className="text-muted mb-5">{t('LANDING_PAGE_BLOG_LATEST_FROM_US_LABEL')}</p>
            </div>
          </div>
          <div className="row justify-content-center">
            {blogs.length > 0 ? (
              <Fragment>
                <div className="clearfix"></div>

                <div className=" w-100 row justify-content-center">
                  {blogs.map((blog) => {
                    return (
                      <BlogCard key={blog.id} blog={blog} />
                    );
                  })}
                </div>
              </Fragment>
            ) : (
              <div className="full-width text-center">
                <h5>{t('LANDING_PAGE_BLOG_NO_BLOGS_MESSAGE')}</h5>
              </div>
            )}
          </div>
        </div>
      </section>) : null}
    </Fragment>
  );
};

export default withRouter(ListSection);
